<template>
    <div class="d-flex flex-column bdk-mx-auto bdk-details-screen detail-text">
        <div>
            <h2 class="detail-title">{{ __('Sobre o Forwhats') }} </h2>
            <p>{{ __('O Forwhats é uma solução de integração para o WhatsApp Web que otimiza a comunicação com clientes, leads e contatos, oferecendo recursos avançados para automação e organização. Com ele, você mantém seu CRM sempre atualizado, registrando conversas e informações essenciais de forma prática e eficiente.') }}</p>
        </div>

        <div class="bdk-w-full bdk-border-t bdk-border-gray-300 bdk-mx-auto bdk-my-8"></div>
        <div>
            <h2 class="detail-title">{{ __('Como integrar?') }}</h2>
            <p class="mb-3">{{ __('Usar o Forwhats é simples e rápido.') }}</p>
            <p>{{ __('1. Faça seu cadastro no Forwhats')}} <br>
            {{ __('2. Gere o token em “ Configurar Forwhats”') }} <br>
            {{ __('3. Adicione o token gerado em “Integrações” no Forwhats.') }} 
            </p>
        </div>
        <button class="btn btn-link" @click="openForWhats">{{ __('Conheça o Forwhats') }}</button>
    </div>
</template>
<style lang="scss" scoped>
    @import '../../../sass/variables';
    .bdk-details-screen {
        max-width:824px;
    }

    .detail-title {
        color: $salesflow-font-dark;
        font-family: Montserrat;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: 150%;
        margin-bottom: 16px;
    }

    .detail-text {
        color: $salesflow-font-dark;
        font-family: Montserrat;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 150%;
    }

    .btn-link {
        width: 211px;
        padding: 12px 16px;
        border-radius: 12px;
        background: #90E26A;
        margin-top: 20px;
        color: #242424;
        font-family: Inter;
        font-size: 16px;
    }

    .btn-link:hover {
        background-color: #49A235;
        color: $salesflow-font-white;
        text-decoration: none;
    }

    .btn-link:focus {
        text-decoration: none;
    }
</style>
<script>
export default {
    methods: {
        openForWhats() {
            window.open('https://forwhats.com.br/', '_blank');
        }
    }
}
</script>